import type { Authenticator } from "@app/lib/auth";
import type { UserResource } from "@app/lib/resources/user_resource";
import {
  ONBOARDING_STEP_DONE_VALUE,
  ONBOARDING_STEP_METADATA_KEY,
  ONBOARDING_STEP_QUEUED_VALUE,
  TIMEZONE_METADATA_KEY,
} from "@app/types/onboarding";

export const ONBOARDING_CONVERSATION_ENABLED = true;

export function shouldEnterOnboarding(stepValue: string | null): boolean {
  return stepValue === ONBOARDING_STEP_QUEUED_VALUE;
}

export async function queueOnboardingWizard(user: UserResource): Promise<void> {
  const step = await user.getMetadata(ONBOARDING_STEP_METADATA_KEY);
  if (step?.value === ONBOARDING_STEP_DONE_VALUE) {
    return;
  }
  await user.setMetadata(
    ONBOARDING_STEP_METADATA_KEY,
    ONBOARDING_STEP_QUEUED_VALUE
  );
}

export async function getUserTimezone(auth: Authenticator): Promise<string> {
  const user = auth.user();
  if (!user) {
    return "UTC";
  }

  const metadata = await user.getMetadata(TIMEZONE_METADATA_KEY);
  return metadata?.value ?? "UTC";
}
